// WarnModal.jsx
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  z-index: 9999;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 1.2rem;
  padding: 2.4rem 2rem 1.6rem 2rem;
  max-width: 90vw;
  width: 350px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: #d97706;
  margin-bottom: 1.2rem;
  text-align: center;
`;

const Message = styled.div`
  font-size: 1.1rem;
  color: #22223b;
  margin-bottom: 2rem;
  text-align: center;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 1.2rem;
  width: 100%;
  justify-content: center;
`;

const ModalButton = styled.button`
  padding: 0.7rem 1.6rem;
  border-radius: 0.7rem;
  border: none;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  background: ${({ $danger }) => ($danger ? "#ff3333" : "#d97706")};
  color: #fff;
  transition: background 0.2s;
  &:hover {
    background: ${({ $danger }) => ($danger ? "#e60000" : "#b45309")};
  }
`;

export default function WarnModal({ open, onConfirm, onCancel, message }) {
  if (!open) return null;
  return (
    <Overlay>
      <ModalBox>
        <Title>Atenção</Title>
        <Message>
          {message}
          <br />
          Deseja continuar?
        </Message>
        <ButtonRow>
          <ModalButton onClick={onCancel} $danger>
            Cancelar
          </ModalButton>
          <ModalButton onClick={onConfirm}>Continuar</ModalButton>
        </ButtonRow>
      </ModalBox>
    </Overlay>
  );
}
